import { Popover, Tooltip } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { SubMenuIconWrapper, SubMenuWrapper, TextLink } from '../Styles/Styles'
import { FaForumTagsIcon } from '../../../Images/icon'
import useClickOutside from '../../../../hooks/useClickOutside/useClickOutside'

const permission = JSON.parse(localStorage.getItem("permissions")) || [];

const forumAccess = permission.find((o) => o.slug === "forum");


const ForumSubMenu = () => {

    const hasReadPermissionForForums = forumAccess?.permissions?.find((o) => o.slug === "read")

    const popoverRef = useRef(null);
    const isOutsideClicked = useClickOutside(popoverRef);

    const [anchorEl, setAnchorEl] = React.useState(null);

    useEffect(() => {
        if (isOutsideClicked) {
            handleClose();
        }
    }, [isOutsideClicked])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if (!hasReadPermissionForForums) return null

    return (
        <>
            <Tooltip title='Forum' placement="right">
                <SubMenuIconWrapper
                    onClick={handleClick}
                >
                    <FaForumTagsIcon />
                </SubMenuIconWrapper>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                ref={popoverRef}
            >
                <SubMenuWrapper>
                    <TextLink
                        to="/tags"
                        onClick={handleClose}>
                        Tags
                    </TextLink>
                    <TextLink
                        to="/forum-flags"
                        onClick={handleClose}
                    >
                        Flagged comments
                    </TextLink>
                </SubMenuWrapper>
            </Popover>
        </>
    )
}

export default ForumSubMenu